import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "@app/env";
import { AngularFireDatabase } from "angularfire2/database";
import { AngularFirestore } from "angularfire2/firestore";
import { Observable } from "rxjs/Observable";
import { catchError, switchMap } from "rxjs/operators";
import { Utilities } from "./utilities";
import { AuthData } from "./auth";
import { of } from "rxjs/observable/of";
import { IClient } from "../shared/models/client.model";

@Injectable()
export class PollData {

  constructor(
    private afDb: AngularFireDatabase,
    private afStore: AngularFirestore,
    private http: HttpClient,
    private utilities: Utilities,
    private authData: AuthData,
  ) { }

  public getPollsByClient(client: string): Observable<any[]> {
    return this.afDb.list<any>(`Clients/${client}/Surveys`).
      valueChanges();
  }

  public getPollById(client: string, id: string): Observable<any> {
    return this.afDb.object<any>(`Clients/${client}/Surveys/${id}`).
      valueChanges();
  }

  public createPoll(client: string, poll: any) {
    if (poll.id === "") { poll.id = this.afDb.createPushId(); }

    return new Promise((resolve, reject) => {
      return this.afDb.database.ref(`Clients/${client}/Surveys/${poll.id}`)
        .update({ id: poll.id, general: poll })
        .then(() => {
          resolve(poll);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public getQuestionByPollId(client: string, id: string, questionId: string): Observable<any> {
    return this.afDb.object<any>(`Clients/${client}/Surveys/${id}/questions/${questionId}`).
      valueChanges();

  }

  public updateQuestionByPollId(client: string, id: string, question: any): Observable<any> {
    if (question.id === "") { question.id = this.afDb.createPushId(); }
    return Observable.fromPromise(
      this.afDb.object(`Clients/${client}/Surveys/${id}/questions/${question.id}`)
        .update(question));
  }

  public getPollAnswers(clientId: string, pollId: string) {
    return this.afDb.object<any>(`Clients/${clientId}/Interactivity/SurveyAnswers/${pollId}`).
      valueChanges();
  }

  public getPollEventAnswers(clientId: string, eventId: string, pollId: string) {
    return this.afDb.object<any>(`Clients/${clientId}/Event/${eventId}/SurveyAnswers/${pollId}`).
      valueChanges();
  }

  public getPollXls(clientId: string, pollId: string, eventId: string = null): Observable<any> {
    return this.authData.getTokenUser().pipe(
      switchMap((token: string) => {
        const headers = new HttpHeaders({ 'Authorization': token })
        return this.http.get(`${ENV.reports_url}/reports/survey/${clientId}/${eventId}/${pollId}`, { headers });
      })
    );
  }

  public setVisibilityQuestion(clientId, pollId, questionId, value) {
    return this.afDb.object(`/Clients/${clientId}/Surveys/${pollId}/questions/${questionId}`).update({
      isVisible: value,
    });
  }

  // public getJSONPoll(clientId: string, pollId: string, eventId: string = null) {
  //   let httpObs;
  //   if (this.utilities.validateEventIdParam(eventId)) {
  //     httpObs = this.http.get(`${ENV.backend}/util/polls/${clientId}/${eventId}/${pollId}`);
  //   } else {
  //     httpObs = this.http.get(`${ENV.backend}/util/polls/${clientId}/${pollId}`);
  //   }

  //   return httpObs;
  // }

  public sendReportSurvey(client: IClient, emailUser: string, eventId: string, survey, eventName: string): Observable<any> {
    return this.authData.getTokenUser().pipe(
      switchMap((token: string) => {
        if (!token) {
          return of([]);
        }
        const headers = new HttpHeaders({ Authorization: token });

        const subject = eventId === '--' ?
          'Reporte de la encuesta: ' + survey.general.title.es + ' del cliente: ' + client.name :
          'Reporte de la encuesta: ' + survey.general.title.es + ' en el evento: ' + eventName + ' del cliente: ' + client.name;

        // return this.http.post(`${ENV.jobs_url}/v1/reports/survey`,
        return this.http.post(`${ENV.backend}/reports/generate_surveys`,
          {
            "clientId": client.id,
            "eventId": eventId,
            "id": survey.id,
            "email": emailUser,
            "subject": subject
          },
          { headers });
      }),
    );
  }
}
 // end file



// WEBPACK FOOTER //
// ./src/providers/poll.ts